var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 62,
    viewBox: "0 0 38 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_58_878)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_58_878",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -0.799805,
    width: 35,
    height: 59,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    y: -0.799805,
    width: 35,
    height: 59
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00098 3H8.80078V8.80078H14.5996V49.4004H8.80078V55.2002H3.00098V3ZM14.6006 14.5996H20.4004V20.4004H26.1992V37.7998H20.4004V43.5996H14.6006V14.5996ZM26.2002 26.2002H32V32H26.2002V26.2002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.00098 3H8.80078V8.80078H14.5996V49.4004H8.80078V55.2002H3.00098V3ZM14.6006 14.5996H20.4004V20.4004H26.1992V37.7998H20.4004V43.5996H14.6006V14.5996ZM26.2002 26.2002H32V32H26.2002V26.2002Z",
    fill: "#527E82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.00098 3V0H0.000976562V3H3.00098ZM8.80078 3H11.8008V0H8.80078V3ZM8.80078 8.80078H5.80078V11.8008H8.80078V8.80078ZM14.5996 8.80078H17.5996V5.80078H14.5996V8.80078ZM14.5996 49.4004V52.4004H17.5996V49.4004H14.5996ZM8.80078 49.4004V46.4004H5.80078V49.4004H8.80078ZM8.80078 55.2002V58.2002H11.8008V55.2002H8.80078ZM3.00098 55.2002H0.000976562V58.2002H3.00098V55.2002ZM14.6006 14.5996V11.5996H11.6006V14.5996H14.6006ZM20.4004 14.5996H23.4004V11.5996H20.4004V14.5996ZM20.4004 20.4004H17.4004V23.4004H20.4004V20.4004ZM26.1992 20.4004H29.1992V17.4004H26.1992V20.4004ZM26.1992 37.7998V40.7998H29.1992V37.7998H26.1992ZM20.4004 37.7998V34.7998H17.4004V37.7998H20.4004ZM20.4004 43.5996V46.5996H23.4004V43.5996H20.4004ZM14.6006 43.5996H11.6006V46.5996H14.6006V43.5996ZM26.2002 26.2002V23.2002H23.2002V26.2002H26.2002ZM32 26.2002H35V23.2002H32V26.2002ZM32 32V35H35V32H32ZM26.2002 32H23.2002V35H26.2002V32ZM3.00098 3V6H8.80078V3V0H3.00098V3ZM8.80078 3H5.80078V8.80078H8.80078H11.8008V3H8.80078ZM8.80078 8.80078V11.8008H14.5996V8.80078V5.80078H8.80078V8.80078ZM14.5996 8.80078H11.5996V49.4004H14.5996H17.5996V8.80078H14.5996ZM14.5996 49.4004V46.4004H8.80078V49.4004V52.4004H14.5996V49.4004ZM8.80078 49.4004H5.80078V55.2002H8.80078H11.8008V49.4004H8.80078ZM8.80078 55.2002V52.2002H3.00098V55.2002V58.2002H8.80078V55.2002ZM3.00098 55.2002H6.00098V3H3.00098H0.000976562V55.2002H3.00098ZM14.6006 14.5996V17.5996H20.4004V14.5996V11.5996H14.6006V14.5996ZM20.4004 14.5996H17.4004V20.4004H20.4004H23.4004V14.5996H20.4004ZM20.4004 20.4004V23.4004H26.1992V20.4004V17.4004H20.4004V20.4004ZM26.1992 20.4004H23.1992V37.7998H26.1992H29.1992V20.4004H26.1992ZM26.1992 37.7998V34.7998H20.4004V37.7998V40.7998H26.1992V37.7998ZM20.4004 37.7998H17.4004V43.5996H20.4004H23.4004V37.7998H20.4004ZM20.4004 43.5996V40.5996H14.6006V43.5996V46.5996H20.4004V43.5996ZM14.6006 43.5996H17.6006V14.5996H14.6006H11.6006V43.5996H14.6006ZM26.2002 26.2002V29.2002H32V26.2002V23.2002H26.2002V26.2002ZM32 26.2002H29V32H32H35V26.2002H32ZM32 32V29H26.2002V32V35H32V32ZM26.2002 32H29.2002V26.2002H26.2002H23.2002V32H26.2002Z",
    fill: "#062435",
    mask: "url(#path-1-outside-1_58_878)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_58_878",
    x: 0,
    y: 0,
    width: 38,
    height: 61.2002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.203922 0 0 0 0 0.270588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_58_878"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_58_878",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRight);
export default __webpack_public_path__ + "static/media/img_right.3d6d0f6883e02b29cc362fd8b75335c9.svg";
export { ForwardRef as ReactComponent };